import React, { Component } from "react";
import MainLayout from "../mainLayout/index";
import FpgMinusIcon from "../icons/fpgminusicon";
import PlusIcon from "../icons/plusicon";
import DraggerIcon from "../icons/draggericon";
import EditIcon from "../icons/EditIcon";
import delet from "../assets/images/delet.svg";
import TextField from "./TextField";
import TextEditor from "./TextEditor";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
//Validation import
import SimpleReactValidator from "simple-react-validator";
import { isEqual, cloneDeep } from "lodash";


//sweet alert
import swal from "sweetalert";

//Service import
import service from "../services";
import Loader from "./loader";
import moment from "moment";

let sub;
class WaitlistFaq extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      question: "",
      answer: EditorState.createEmpty(),
      loaderFlag: false,
      isDraggable: false,
      changeQuestionTitleName: false,
      getAllQuestionDetails: [],
      getAllQuestionDocs: [],
      id: "",
      isDraggable: false,
      eventiveId:'',
      showTags:true,
      showFilters:true,
      isEdited: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  normalizeDraftHtml = (editorState) => {
    if (!editorState || typeof editorState === "string") return "";
    const content =
      typeof editorState.getCurrentContent === "function"
        ? editorState.getCurrentContent()
        : null;
    if (!content || !content.hasText()) return "";
    const html = draftToHtml(convertToRaw(content)).trim();
    return html === "<p></p>\n" || html === "<p></p>" || html === "<div></div>"
      ? ""
      : html;
  };

  getCurrentFormData = () => {
    return cloneDeep({
      questions: (this.state.getAllQuestionDocs || []).map((faq) => ({
        question: faq.question || "",
        answer: faq.answer || "",
      })),
      // Tracking current modal state
      modalQuestion: this.state.addCatmodal ? this.state.question || "" : null,
      modalAnswer: this.state.addCatmodal ? this.normalizeDraftHtml(this.state.answer) : null,
    });
  };

  markEdited = () => {
    if (this.state.initialData) {
      const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
      if (this.state.isEdited !== isDirty) {
        this.setState({ isEdited: isDirty });
      }
    }
  };

  updateState = (data, callback) => {
    this.setState(data, () => {
      this.markEdited();
      if (callback) callback();
    });
  };

  AddQuestion = () => {
    this.validator.hideMessages("");
    this.setState({
      addCatmodal: true,
      question: "",
      answer: "",
    }, () => {
      this.setState({ initialData: this.getCurrentFormData(), isEdited: false });
    });
  };
  CloseModal = () => {
    this.setState({
      addCatmodal: false,
      question: "",
      answer: "",
      changeQuestionTitleName: false,
      id: '',
    }, () => {
      this.setState({ initialData: this.getCurrentFormData(), isEdited: false });
    });
    this.validator.hideMessages("");
  };
  componentDidMount = async () => {
    this.getAllQuestion();
    this.getquestion();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getquestion = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "ticketCms|ticketHome|getList":
          this.setState(
            {
              getAllQuestionDetails: response.data,
              getAllQuestionDocs: response.data.docs[0].waitlistFaq,
            },
            () => {
              this.setState({
                loaderFlag: false,
                initialData: this.getCurrentFormData(),
                isEdited: false
              });
            }
          );
          break;
        case "waitList|faq|create":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                addCatmodal: false,
                loaderFlag: false,
                question: "",
                answer: "",
                changeQuestionTitleName: false,
              }, () => {
                this.setState({ initialData: this.getCurrentFormData(), isEdited: false });
              });
            this.apiserve.success("Question added successful.");
          }
          this.getAllQuestion();
          break;
        case "waitList|faq|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
          this.setState(
            {
              addCatmodal: false,
              changeQuestionTitleName: false,
              question: "",
              answer: "",
              loaderFlag: false
            }, () => {
              this.setState({ initialData: this.getCurrentFormData(), isEdited: false });
            });
            this.apiserve.success("Question updated Successful.");
          }
          this.getAllQuestion();
          break;
        case "waitList|faq|delete":
          this.getAllQuestion();
          break;
        case "waitList|faq|changeOrder":
          break;
      }
    });
  };

  getAllQuestion = () => {
    this.apiserve.sendevent("ticketCms|ticketHome|getList", {});
  };

  onInputChange = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };


  onEditorStateChange = answer => {
    this.updateState({
      answer
    });
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const name = convertToRaw(this.state.answer.getCurrentContent());
      const markup = draftToHtml(name);
      if (this.state.changeQuestionTitleName) {
        let updateQue = {
          answer: markup,
          question: this.state.question,
          waitlistFaqId: this.state.id,
          id: this.state.getAllQuestionDetails.docs[0]._id,
        };
        this.apiserve.sendevent("waitList|faq|update", updateQue);
      } else {
        let data = {
          answer: markup,
          question: this.state.question,
          id: this.state.getAllQuestionDetails.docs[0]._id,
        };
        this.apiserve.sendevent("waitList|faq|create", data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  editQuestion = async (item) => {
    this.setState({
      addCatmodal: true,
      changeQuestionTitleName: true,
      question: item.question,
      answer: this.getAnwserHtmlToEditor(item.answer),
      id: item._id,
    }, () => {
      this.setState({ initialData: this.getCurrentFormData(), isEdited: false });
    });
    this.validator.hideMessages("");
  };

  deleteQuestion = async (item) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Your record has been deleted!", {
          icon: "success",
        });
        let data = {
          waitlistFaqId: item._id,
          id: this.state.getAllQuestionDetails.docs[0]._id,
        };
        this.apiserve.sendevent("waitList|faq|delete", data);
      } else {
        swal("Your record is safe!");
      }
    });
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.getAllQuestionDocs];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        waitlistFaqId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    const data = { order: updateArr };
    this.apiserve.sendevent("waitList|faq|changeOrder", data);
    this.setState({ getAllQuestionDocs: arr });
  };

  getAnwserHtmlToEditor = (html) => {
    const fieldValue = html ?? '';
    const blocksFromHtml = htmlToDraft(fieldValue);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorState = EditorState.createWithContent(contentState);
    return editorState;
  }

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };
  render() {
    const { getAllQuestionDocs, changeQuestionTitleName } = this.state;
    return (
      <React.Fragment>
        <div className="ticketing_faq_page">
          <div>
            <div className="category_add_edit">
              <div className="table_wrap product_list_tbl film_list_table striped_table">
              <table>
                <thead>
                <tr>
                  <th></th>
                  <th>Question</th>
                  <th>Answer</th>
                  <th>Last Updated Date (MT)</th>
                  <th>Updated By (MT)</th>
                  <th> </th>
                </tr>
                </thead>
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided, snapshot) => (
                        <tbody {...provided.droppableProps} ref={provided.innerRef}>
                          {getAllQuestionDocs?.map((item, index) => (
                            <Draggable
                              key={item._id}
                              draggableId={item._id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <tr
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <td>
                                    <DraggerIcon />
                                  </td>
                                  <td>{item.question}</td>
                                  <td><div class="display_name" dangerouslySetInnerHTML={{__html:item.answer}} /></td>
                                  <td>{moment.tz(item.lastUpdated, "US/Mountain").format("MM/DD/YYYY")}</td>
                                  <td>{item.updatedBy && item.updatedBy.fname} {item.updatedBy && item.updatedBy.lname}</td>
                                  <td>
                                    <div className="action_wrap d_flex">
                                      <span className="cat_edit pointer" onClick={() => this.editQuestion(item)} >
                                        <EditIcon />
                                      </span>
                                      <span className="remove_cat pointer" onClick={() => this.deleteQuestion(item)} >
                                        <img src={delet} alt="delet" />
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                        </tbody>
                      )}
                    </Droppable>
                  </DragDropContext>
                  </table>
              </div>
            </div>
          </div>
          <div className={`user_popup ${this.state.addCatmodal ? "active" : ""}`} >
            <span className="popup_overlay" onClick={this.CloseModal}></span>
            <div className="cat_modal_inner">
              <p className="cat_title text_center">
                {changeQuestionTitleName ? "Edit FAQ" : "Add FAQ"}
              </p>
              <form>
                <div className="field_row horizontal_field d_flex">
                  <TextField
                    type="text"
                    label="Question"
                    name="question"
                    value={this.state.question}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message(
                      "Question",
                      this.state.question,
                      "required"
                    )}
                  />
                </div>
                <div className="field_row horizontal_field d_flex">
                  <div className="field_row_inner">
                    <label>Answer</label>
                    <div className="field_input relative editor_wrapper">
                      <TextEditor
                        name="answer"
                        editorState={this.state.answer}
                        value={this.state.answer}
                        onEditorStateChange={e => this.onEditorStateChange(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="cat_btns text_center">
                  <button type="button" onClick={this.CloseModal}>
                    CANCEL
                  </button>
                  <button
                    className={changeQuestionTitleName && !this.state.isEdited ? "disabled" : "active"}
                    disabled={changeQuestionTitleName && !this.state.isEdited}
                    onClick={(e) => this.submitFn(e)}
                  >
                    SAVE
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default WaitlistFaq;
